"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesStringContain = exports.findInString = void 0;
function findInString(str, re) {
    if (str === undefined)
        return '';
    var reExec = re.exec(str);
    if (reExec != null)
        return reExec[1] != null ? reExec[1] : '';
    else
        return '';
}
exports.findInString = findInString;
function doesStringContain(str, re) {
    if (str === undefined)
        return false;
    return str.match(re) !== null;
}
exports.doesStringContain = doesStringContain;
//# sourceMappingURL=string-helpers.js.map